import React from 'react';

const normalize = (text: string) => text.toLowerCase().replace(/ё/g, 'е');

/**
 * Оборачивает в <mark> вхождения слов без учёта регистра и разницы между «е» и «ё».
 * Пересекающиеся и соседние вхождения выделяются одним куском, поэтому слово
 * и его основа («скоро» и «скор») дают одно выделение по всему слову.
 */
const highlightWords = (text: string, words: string[]): React.ReactNode => {
  const normalizedText = normalize(text);

  // на редких символах toLowerCase меняет длину строки, и позиции разъедутся
  if (normalizedText.length !== text.length) return text;

  const ranges = words
    .map(normalize)
    .filter(Boolean)
    .flatMap((word) => {
      const found: Array<[number, number]> = [];
      let index = normalizedText.indexOf(word);

      while (index !== -1) {
        found.push([index, index + word.length]);
        index = normalizedText.indexOf(word, index + word.length);
      }

      return found;
    })
    .sort(([a], [b]) => a - b)
    .reduce<Array<[number, number]>>((merged, [start, end]) => {
      const last = merged[merged.length - 1];

      if (last && start <= last[1]) last[1] = Math.max(last[1], end);
      else merged.push([start, end]);

      return merged;
    }, []);

  const parts: React.ReactNode[] = [];
  let cursor = 0;

  ranges.forEach(([start, end]) => {
    if (start > cursor) parts.push(text.slice(cursor, start));
    parts.push(<mark key={start}>{text.slice(start, end)}</mark>);
    cursor = end;
  });

  if (cursor < text.length) parts.push(text.slice(cursor));

  return parts;
};

export default highlightWords;
